import type { AuthConfig } from "@agentech/auth-client";

const ENV_CONFIG = {
  dev: {
    baseDomain: "agentech-dev.com",
    cognitoDomainPrefix: "agentech-dev",
    clientId: "usv1sk2cpepr2642mea48cbjd",
  },
  stage: {
    baseDomain: "agentech-stage.com",
    cognitoDomainPrefix: "agentech-stage",
    clientId: "pmd88f22e9p09vmgs41c5er9v",
  },
  prod: {
    baseDomain: "agentech.com",
    cognitoDomainPrefix: "agentech",
    clientId: "7o4fmg2559qmlmaf1h7gtbejkq",
  },
} as const;

function getEnvConfig(): AuthConfig {
  const hostname = window.location.hostname;

  // Local development with agentech.local domain (via Caddy reverse proxy)
  if (hostname.endsWith(".agentech.local") || hostname === "agentech.local") {
    // Proxy auth API through Vite dev server so cookies are set on .agentech.local
    return {
      apiBaseUrl: "/auth-api",
      authDomain: "auth.agentech.local",
      baseDomain: "agentech.local",
      cognitoDomain: "https://agentech-dev.auth.us-east-1.amazoncognito.com",
      clientId: ENV_CONFIG.dev.clientId,
    };
  }

  // Determine environment from hostname
  const env = hostname.includes("agentech-dev")
    ? "dev"
    : hostname.includes("agentech-stage")
      ? "stage"
      : "prod";

  const envConfig = ENV_CONFIG[env];

  return {
    apiBaseUrl: `https://auth.${envConfig.baseDomain}`,
    authDomain: `auth.${envConfig.baseDomain}`,
    baseDomain: envConfig.baseDomain,
    cognitoDomain: `https://${envConfig.cognitoDomainPrefix}.auth.us-east-1.amazoncognito.com`,
    clientId: envConfig.clientId,
  };
}

export const config = getEnvConfig();
